module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("•   Hope Nelson, my lovely bride, my best friend and my partner in crime.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("•   George Combs, for helping me navigate Alexandria Local History Special Collections.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("•   Julie Downie, for helping me translate Victorian euphemisms.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("•   Mary Fishback, for helping me navigate the Thomas Balch Library.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("•   Ruth Lincoln Kaye, for spreading an infectious interest in hidden history.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("•   Ted Pulliam, for helping me whip this wicked project into shape.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fb67f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 69
// module chunks = 0